// Per-tab persistence for an anonymous trial result.
//
// Anonymous (not-signed-in) analyses live only in Vuex, so a refresh, a
// deep-link, or the in-app navigation that does a hard reload used to drop the
// user back to a blank upload page — losing the result they just waited for.
// Authenticated analyses don't have this problem: they're persisted to
// Firestore and rehydrated by id.
//
// We mirror the trial result into sessionStorage (per-tab, cleared when the tab
// closes — appropriate for a throwaway trial, and privacy-friendlier than
// localStorage). The uploaded image itself is served from the backend
// `/uploads/...` path, so the stored imageUrl still resolves after a reload.
const KEY = 'trial-analysis-snapshot';

export function saveTrialSnapshot(snapshot) {
  if (!snapshot || !snapshot.analysis || !snapshot.imageUrl) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch (_) {
    // best-effort; trial persistence is a convenience, never a hard dependency
  }
}

export function readTrialSnapshot() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.analysis && parsed.imageUrl ? parsed : null;
  } catch (_) {
    return null;
  }
}

export function clearTrialSnapshot() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {
    /* best-effort */
  }
}
